

export const LOADER_STATUS = 'boilerplate/ProfileManagement/LOADER_STATUS';
export const PROFILE_DATA = 'boilerplate/ProfileManagement/PROFILE_DATA';
export const RESPONSE_MESSAGE = 'boilerplate/ProfileManagement/RESPONSE_MESSAGE';
export const SET_RADIO_VAL = 'boilerplate/ProfileManagement/SET_RADIO_VAL';
export const RESPONSE_MULTIPLE_MESSAGE = 'boilerplate/ProfileManagement/RESPONSE_MULTIPLE_MESSAGE';
